import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc737ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row k-mb-4 row justify-content-center" }
const _hoisted_3 = { class: "col-7" }
const _hoisted_4 = { class: "labeled-block-row mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " Title: ", -1))
const _hoisted_6 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_7 = {
  key: 0,
  class: "labeled-block-row mb-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " Slug: ", -1))
const _hoisted_9 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_10 = { class: "labeled-block-row mb-2" }
const _hoisted_11 = { class: "labeled-block-row mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " SEO title: ", -1))
const _hoisted_13 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_14 = { class: "labeled-block-row mb-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " Short text: ", -1))
const _hoisted_16 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_17 = { class: "labeled-block-row mb-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " Meta description: ", -1))
const _hoisted_19 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_20 = { class: "labeled-block-row mb-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labeled-block-row_label labeled-block-row_label__text-right fw-bold" }, " Reading time (minutes): ", -1))
const _hoisted_22 = { class: "labeled-block-row_data labeled-block-row_data__w-90 text-start" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { class: "row mb-4 k-align-items-center" }
const _hoisted_25 = { class: "col-12 text-start mb-2" }
const _hoisted_26 = { class: "upload-wrapper" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Choose a file", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" or drag it here ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "k-text-error"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "col-12 k-text-center"
}
const _hoisted_34 = {
  key: 1,
  class: "col-12"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-2\" data-v-dc737ba4><div class=\"col-1 k-text-center\" data-v-dc737ba4><b data-v-dc737ba4>Main</b></div><div class=\"col-2 k-text-center\" data-v-dc737ba4><b data-v-dc737ba4>Preview</b></div><div class=\"col-3\" data-v-dc737ba4><b data-v-dc737ba4>File name</b></div><div class=\"col-4\" data-v-dc737ba4><b data-v-dc737ba4>Alt description</b></div></div>", 1)
const _hoisted_36 = { class: "col-1 k-text-center" }
const _hoisted_37 = ["checked", "value"]
const _hoisted_38 = { class: "col-2 k-text-center" }
const _hoisted_39 = ["src"]
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "col-4" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "col-2 k-text-center" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "col-3" }
const _hoisted_47 = {
  key: 0,
  class: "k-text-left k-mb-2"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_49 = { class: "k-d-flex k-align-items-center k-justify-content-between k-mb-4" }
const _hoisted_50 = { class: "labeled-block k-mb-8 k-pb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Talent")
], -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "labeled-block_elem k-d-flex k-justify-content-center" }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-2 k-mr-8" }, null, -1))
const _hoisted_56 = { class: "labeled-block-row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block-row_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Email:")
], -1))
const _hoisted_58 = { class: "labeled-block-row_data k-mb-0" }
const _hoisted_59 = { class: "labeled-block-row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block-row_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Full Name:")
], -1))
const _hoisted_61 = { class: "labeled-block-row_data k-mb-0" }
const _hoisted_62 = { class: "labeled-block-row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block-row_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Location:")
], -1))
const _hoisted_64 = { class: "labeled-block-row_data k-mb-0" }
const _hoisted_65 = {
  key: 0,
  class: "labeled-block-row k-mb-0 k-pb-0"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block-row_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Skills:")
], -1))
const _hoisted_67 = { class: "labeled-block-row_data k-mb-0" }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "labeled-block-row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Email:", -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "labeled-block-row_data k-mb-0" }
const _hoisted_73 = { class: "k-d-flex k-justify-content-end" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { class: "labeled-block k-mb-8 k-px-3" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Categories")
], -1))
const _hoisted_77 = { class: "col-12 card k-pt-2 k-pb-1 k-px-3 k-mb-4" }
const _hoisted_78 = { class: "d-wrap" }
const _hoisted_79 = { class: "label-item__title" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 1,
  class: "pb-1"
}
const _hoisted_82 = { class: "k-mb-5" }
const _hoisted_83 = { class: "row k-align-items-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, "Skills:", -1))
const _hoisted_85 = { class: "col-10" }
const _hoisted_86 = { class: "k-mb-5" }
const _hoisted_87 = { class: "row k-align-items-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, "Country:", -1))
const _hoisted_89 = { class: "col-10" }
const _hoisted_90 = { class: "k-mb-4" }
const _hoisted_91 = { class: "row k-align-items-center k-mb-2" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, "City/town:", -1))
const _hoisted_93 = { class: "col-10" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-8" }
const _hoisted_96 = { class: "col-4" }
const _hoisted_97 = { class: "k-mb-2" }
const _hoisted_98 = { class: "row k-align-items-center k-mb-2" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, "Custom:", -1))
const _hoisted_100 = { class: "col-10" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-8" }
const _hoisted_103 = { class: "col-4" }
const _hoisted_104 = {
  key: 1,
  class: "labeled-block"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "labeled-block_label k-mb-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Activity log")
], -1))
const _hoisted_106 = { class: "labeled-block_wrapper" }
const _hoisted_107 = { class: "table table-bordered activity-log-table" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Author"),
  /*#__PURE__*/_createElementVNode("th", null, "Time")
], -1))
const _hoisted_109 = { class: "k-d-flex k-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_tool = _resolveComponent("editor-tool")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CustomMultiselect = _resolveComponent("CustomMultiselect")!
  const _component_kendo_notification = _resolveComponent("kendo-notification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Title) = $event)),
              type: "text",
              placeholder: "The title of the post",
              class: _normalizeClass(["form-control", {
                'k-border-error k-text-error':
                  _ctx.errors.Title && _ctx.errors.Title !== null,
              }]),
              maxlength: "200"
            }, null, 2), [
              [_vModelText, _ctx.form.Title]
            ]),
            (_ctx.errors.Title && _ctx.errors.Title !== null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({
                'k-border-error k-text-error':
                  _ctx.errors.Title && _ctx.errors.Title !== null,
              })
                }, _toDisplayString(_ctx.errors.Title.msg), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.mode === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Slug) = $event)),
                  type: "text",
                  placeholder: "Slug of the post",
                  class: _normalizeClass(["form-control", {
                'k-border-error k-text-error':
                  _ctx.errors.Slug && _ctx.errors.Slug !== null,
              }]),
                  maxlength: "200"
                }, null, 2), [
                  [_vModelText, _ctx.form.Slug]
                ]),
                (_ctx.errors.Slug && _ctx.errors.Slug !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({
                'k-border-error k-text-error':
                  _ctx.errors.Slug && _ctx.errors.Slug !== null,
              })
                    }, _toDisplayString(_ctx.errors.Slug.msg), 3))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["labeled-block-row_label labeled-block-row_label__text-right fw-bold", { 'k-text-error': _ctx.errors.Text }])
          }, " Article: ", 2),
          _createElementVNode("div", {
            id: "editor",
            class: _normalizeClass(["labeled-block-row_data labeled-block-row_data__w-90 text-start", { 'k-border-error': _ctx.errors.Text }])
          }, [
            _createVNode(_component_editor, {
              modelValue: _ctx.form.Text,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Text) = $event)),
              "resizable-content": true,
              "resizable-toolbar": true,
              style: {"height":"450px"},
              rows: "10",
              cols: "30"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_editor_tool, { name: 'formatting' }),
                _createVNode(_component_editor_tool, { name: 'bold' }),
                _createVNode(_component_editor_tool, { name: 'italic' }),
                _createVNode(_component_editor_tool, { name: 'insertImage' }),
                _createVNode(_component_editor_tool, { name: 'insertUnorderedList' }),
                _createVNode(_component_editor_tool, { name: 'insertOrderedList' }),
                _createVNode(_component_editor_tool, { name: 'createLink' }),
                _createVNode(_component_editor_tool, { name: 'unlink' })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.SeoTitle) = $event)),
              type: "text",
              placeholder: "The title of the post",
              class: "form-control",
              maxlength: "200"
            }, null, 512), [
              [_vModelText, _ctx.form.SeoTitle]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.ShortText) = $event)),
              type: "text",
              rows: "3",
              placeholder: "Preview text of the post",
              class: _normalizeClass(["form-control", {
                'k-border-error k-text-error':
                  _ctx.errors.ShortText && _ctx.errors.ShortText !== null,
              }]),
              maxlength: "2000"
            }, null, 2), [
              [_vModelText, _ctx.form.ShortText]
            ]),
            (_ctx.errors.ShortText && _ctx.errors.ShortText !== null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({
                'k-border-error k-text-error':
                  _ctx.errors.ShortText && _ctx.errors.ShortText !== null,
              })
                }, _toDisplayString(_ctx.errors.ShortText.msg), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.MetaDescription) = $event)),
              type: "text",
              rows: "3",
              placeholder: "Meta description",
              maxlength: "200",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.MetaDescription]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.ReadingTime) = $event)),
              type: "number",
              placeholder: "Reading time in minutes",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.ReadingTime]
            ])
          ])
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", {
                for: "imagesUpload",
                class: "upload-wrapper_label",
                onDragover: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
                onDragleave: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
                onDrop: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
              }, [
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _createElementVNode("i", null, [
                  (_ctx.form.Images.length < 6)
                    ? (_openBlock(), _createElementBlock("sub", _hoisted_30, "(You can add 6 images)"))
                    : (_openBlock(), _createElementBlock("sub", _hoisted_31, "(You have uploaded the maximum 6 images)"))
                ])
              ], 32)
            ]),
            _createElementVNode("input", {
              id: "imagesUpload",
              ref: "file",
              type: "file",
              placeholder: "Meta description",
              class: "form-control",
              multiple: "",
              hidden: "",
              disabled: _ctx.form.Images.length === 6,
              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.previewFiles && _ctx.previewFiles(...args)))
            }, null, 40, _hoisted_32)
          ]),
          (_ctx.imageProcessing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_Loader, {
                  class: "mx-auto",
                  "theme-color": 'primary',
                  size: 'large'
                })
              ]))
            : (Array.isArray(_ctx.form.Images) && _ctx.form.Images.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Images, (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["row mb-2 py-1 k-align-items-center", { 'k-bg-light': image.id === _ctx.mainRadio }])
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _withDirectives((_openBlock(), _createElementBlock("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mainRadio) = $event)),
                          key: index,
                          type: "radio",
                          name: "mainImage",
                          checked: _ctx.mainRadio === image.id,
                          value: image.id
                        }, null, 8, _hoisted_37)), [
                          [_vModelRadio, _ctx.mainRadio]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        (image.userPath)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: `/file-service/api/file/pshubcontainer/${image.userPath}/medium/${image.guid}.webp`,
                              alt: "",
                              class: "upload-wrapper_preview-image"
                            }, null, 8, _hoisted_39))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "col-3 file-name-wrap",
                        title: image.fileName
                      }, _toDisplayString(image.fileName), 9, _hoisted_40),
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((image.alt) = $event),
                          type: "text",
                          class: "form-control",
                          placeholder: "Alternative description for image"
                        }, null, 8, _hoisted_42), [
                          [_vModelText, image.alt]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", {
                          class: "k-icon k-i-copy k-icon-64 k-cursor-pointer k-px-5",
                          onClick: ($event: any) => (
                    _ctx.copyUrlToClipboard(
                      `/file-service/api/file/pshubcontainer/${image.userPath}/medium/${image.guid}.webp`,
                    )
                  )
                        }, null, 8, _hoisted_44),
                        _createElementVNode("span", {
                          class: "k-icon k-i-close k-icon-32 k-cursor-pointer k-px-5",
                          onClick: ($event: any) => (_ctx.removeImage(image.id))
                        }, null, 8, _hoisted_45)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        (_ctx.statuses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _hoisted_48,
              _createTextVNode(" " + _toDisplayString(_ctx.getStatus), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("button", {
            class: "btn btn-success k-mr-2",
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.createOrUpdate(-1)), ["prevent","stop"]))
          }, " Save "),
          _createElementVNode("button", {
            class: "btn btn-info k-mr-2",
            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.createOrUpdate(10)), ["prevent","stop"]))
          }, " Preview "),
          (_ctx.mode === 'edit')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary k-mr-2",
                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.changeVisibility()), ["prevent","stop"]))
              }, _toDisplayString(_ctx.actionBtnLabel), 1))
            : _createCommentVNode("", true),
          (_ctx.mode === 'edit')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-danger",
                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.createOrUpdate(0)), ["prevent","stop"]))
              }, " Delete "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          (_ctx.hasTalent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("img", {
                      src: `/file-service/api/file/pshubcontainer/${_ctx.form.Talent.Avatar.userPath}/small/${_ctx.form.Talent.Avatar.guid}.webp`,
                      alt: "",
                      class: "custom-avatar"
                    }, null, 8, _hoisted_54)
                  ]),
                  _hoisted_55
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.form.Talent.Email), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.form.Talent.FullName), 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.form.Talent.Location), 1)
                ]),
                (_ctx.hasSkills)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.skillsList), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["labeled-block-row_label k-mb-0 k-pr-4", { 'k-text-error': _ctx.errors.Talent }])
                  }, _hoisted_71, 2),
                  _createElementVNode("p", _hoisted_72, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.talentEmailForCreate) = $event)),
                      type: "email",
                      class: _normalizeClass(["form-control w-100", { 'k-border-error': _ctx.errors.Talent }]),
                      placeholder: "Enter talent e-mail"
                    }, null, 2), [
                      [_vModelText, _ctx.talentEmailForCreate]
                    ]),
                    (_ctx.errors.Talent && _ctx.errors.Talent !== null)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({
                    'k-border-error k-text-error':
                      _ctx.errors.Talent && _ctx.errors.Talent !== null,
                  })
                        }, _toDisplayString(_ctx.errors.Talent.msg), 3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("button", {
                    class: "btn btn-success labeled-block_btn",
                    disabled: 
                  _ctx.talentEmailForCreate === null || _ctx.talentEmailForCreate === ''
                ,
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.getTalentByEmail && _ctx.getTalentByEmail(...args)))
                  }, " Get talent ", 8, _hoisted_74)
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              (
                  _ctx.categories_result &&
                  Object.values(_ctx.categories_result) &&
                  Object.values(_ctx.categories_result).flat().length > 0
                )
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Object.values(
                    _ctx.categories_result,
                  ).flat(), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "label-item"
                    }, [
                      _createElementVNode("span", _hoisted_79, _toDisplayString(item.Value), 1),
                      _createElementVNode("span", {
                        class: "k-icon k-i-close k-icon-32 k-cursor-pointer",
                        onClick: ($event: any) => (_ctx.removeCategory(item))
                      }, null, 8, _hoisted_80)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_81, "No selected categories"))
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _createElementVNode("div", _hoisted_85, [
                (_ctx.categories_list && _ctx.categories_list.skills)
                  ? (_openBlock(), _createBlock(_component_CustomMultiselect, {
                      key: 0,
                      options: _ctx.categories_list.skills,
                      value: _ctx.categories_result.skills,
                      onChange: _cache[18] || (_cache[18] = 
                    val => {
                      _ctx.combineCategories(val, 'skills');
                    }
                  )
                    }, null, 8, ["options", "value"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _createElementVNode("div", _hoisted_89, [
                (_ctx.categories_list && _ctx.categories_list.countries)
                  ? (_openBlock(), _createBlock(_component_CustomMultiselect, {
                      key: 0,
                      options: _ctx.categories_list.countries,
                      value: _ctx.categories_result.countries,
                      onChange: _cache[19] || (_cache[19] = 
                    val => {
                      _ctx.combineCategories(val, 'countries');
                    }
                  )
                    }, null, 8, ["options", "value"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                (_ctx.categories_list && _ctx.categories_list.cities)
                  ? (_openBlock(), _createBlock(_component_CustomMultiselect, {
                      key: 0,
                      options: _ctx.categories_list.cities,
                      value: _ctx.categories_result.cities,
                      onChange: _cache[20] || (_cache[20] = 
                    val => {
                      _ctx.combineCategories(val, 'cities');
                    }
                  )
                    }, null, 8, ["options", "value"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.new_category_cities) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Add new city"
                }, null, 512), [
                  [_vModelText, _ctx.new_category_cities]
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("button", {
                  class: "btn btn-success w-100 labeled-block_btn",
                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.addCategory(0, _ctx.new_category_cities)), ["prevent","stop"]))
                }, " Add ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                (_ctx.categories_list && _ctx.categories_list.customs)
                  ? (_openBlock(), _createBlock(_component_CustomMultiselect, {
                      key: 0,
                      options: _ctx.categories_list.customs,
                      value: _ctx.categories_result.customs,
                      onChange: _cache[23] || (_cache[23] = 
                    val => {
                      _ctx.combineCategories(val, 'customs');
                    }
                  )
                    }, null, 8, ["options", "value"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.new_category_customs) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Add new custom category"
                }, null, 512), [
                  [_vModelText, _ctx.new_category_customs]
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("button", {
                  class: "btn btn-success w-100 labeled-block_btn",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.addCategory(1, _ctx.new_category_customs)), ["prevent","stop"]))
                }, " Add ")
              ])
            ])
          ])
        ]),
        (_ctx.form.ActivityLog && _ctx.form.ActivityLog.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
              _hoisted_105,
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("table", _hoisted_107, [
                  _hoisted_108,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.ActivityLog, (activity, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.ACTIVITY_CODE[activity.ActivityType]), 1),
                      _createElementVNode("td", null, _toDisplayString(activity.UserFullName), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getDate(activity.TimeStamp)) + " " + _toDisplayString(_ctx.getTime(activity.TimeStamp)), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_kendo_notification, { ref: "popupNotification" }, null, 512)
  ]))
}